import { Play, Pause } from "lucide-react";
import React from "react";

interface VideoOverlayProps {
  isVisible: boolean;
  isPlaying: boolean;
  onPlayPause: () => void;
}

export function VideoOverlay({ isVisible, isPlaying, onPlayPause }: VideoOverlayProps) {
  if (!isVisible) return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black/40">
      <button onClick={onPlayPause} className="p-6 rounded-full bg-purple-500/20 hover:bg-purple-500/30 transition-colors">
        {isPlaying ? <Pause className="w-12 h-12 text-white" /> : <Play className="w-12 h-12 text-white" />}
      </button>
    </div>
  );
}





